// extracted by mini-css-extract-plugin
module.exports = {"cartSF":"styles_cartSF__2KF2C","cantidad":"styles_cantidad__zThR1"};